import * as React from 'react';

const LoadMore = ({ page, maxNumPages, setPage }) => {
	if (maxNumPages > page) {
		const handleOnClick = () => {
			setPage(page + 1);
		};

		const className = 'pfa-load-more__button';
		// className += addingPosts ? ' adding-posts' : '';

		return (
			<div className="pfa-load-more">
				<button className={className} onClick={handleOnClick}>
					Show More
					{false && ( // Disable for now.
						<div className="lds-roller">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					)}
				</button>
			</div>
		);
	}

	return '';
};

LoadMore.displayName = 'LoadMore';

export default LoadMore;
